/*
 * Классы для модалок, свёрстанных вручную (`fixed inset-0` + панель +
 * шапка + тело + кнопки). Те же правила, что у FormModal, но без
 * переписывания разметки:
 *  - окно не выше экрана (100dvh, где нет — 100vh);
 *  - шапка не сжимается, тело занимает остаток, прокрутка — только у тела
 *    и только если на очень маленьком экране поля не влезли;
 *  - кнопки (footerSticky) прилипают к низу тела — видны всегда (у тела
 *    нет нижнего отступа, иначе под кнопками просвечивают поля);
 *  - на невысоких экранах (до 820px) отступы поджаты.
 */
export const modalCls = {
  overlay: 'fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-4',
  panel:
    'relative flex w-full flex-col rounded-xl bg-white shadow-2xl max-h-[calc(100vh-1.5rem)] supports-[height:100dvh]:max-h-[calc(100dvh-1.5rem)]',
  header: 'shrink-0',
  body:
    'min-h-0 flex-1 overflow-y-auto overscroll-contain px-6 pt-3 space-y-3 [@media(min-height:820px)]:pt-4 [@media(min-height:820px)]:space-y-4',
  footerSticky:
    'sticky bottom-0 z-10 -mx-6 rounded-b-xl border-t border-gray-100 bg-white px-6 py-3',
  footerOutside: 'shrink-0',
};
